module.exports = __webpack_public_path__ + "img/IMG_8618_L_Foamcore_MockedUp.2a85d59b.jpg";